import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import ParentFieldDetail from "./detail";
import ParentFieldEdit from "./edit";
import ParentFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type parent en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Parent() {
    return _jsx(_Fragment, { children: "Parent" });
}
var field = fieldsType.parent;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, ParentFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, ParentFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, ParentFieldList);
